<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Radio, Text } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let typeValue, options, _options;
	const optionsLength = options.length - 1;
	const setTypeValue = (_typeValue) => {
		typeValue = _typeValue;
	};
</script>

<Text class="text-bold mb-s">
	{formatSnakeCaseToTitle($format('btn_type_label'))}
</Text>
{#each options as option, i}
	<Radio
		class={classMap({
			'mb-s': i !== optionsLength,
		})}
		selected={typeValue}
		value={option}
		on:click={() => setTypeValue(option)}
		id="radio-ak1qdid"
	>
		{_options[i]}
	</Radio>
{/each}
